import { DecimalValues } from '../../../data-transformer/chart-kpi/decimal-values';
import { KpiValues } from '../../../data-transformer/chart-kpi/kpi-values';
import { DataExecutor } from '../../../data-transformer/data-executor';
import type { ChartDataKPI } from '../../../redux/config/chart-data';
import type { WidgetConfigurationData } from '../../../redux/config/widgetApi';

export default function transformDataChartKPI(widgetConfiguration: WidgetConfigurationData, chartData: ChartDataKPI) {
  if (widgetConfiguration) {
    const commandExecutor = new DataExecutor();
    const kpiValuesResponse = commandExecutor.execute(new KpiValues(), chartData, widgetConfiguration);
    const decimalValuesResponse =
      kpiValuesResponse && commandExecutor.execute(new DecimalValues(), kpiValuesResponse, widgetConfiguration);
    return decimalValuesResponse;
  }
  return undefined;
}
